import { createLocalStorageItem, parseBoolean, parseString } from './localStorageItem'

export const localStorageRefreshTokenKey = 'apiRefreshToken'
export const localStorageTokenKey = 'apiToken'
export const localStorageTenantKey = 'tenant'
export const localStorageAuthenticatedKey = 'authenticated'

export const apiTokenStorage = createLocalStorageItem<string | null>({ key: localStorageTokenKey, fallback: null, parse: parseString })
export const apiRefreshTokenStorage = createLocalStorageItem<string | null>({ key: localStorageRefreshTokenKey, fallback: null, parse: parseString })
export const tenantStorage = createLocalStorageItem<string | null>({ key: localStorageTenantKey, fallback: null, parse: parseString })
export const authenticatedStorage = createLocalStorageItem({ key: localStorageAuthenticatedKey, fallback: false, parse: parseBoolean })
